module.exports = __webpack_public_path__ + "static/media/ghk-logo.a4f831c0.jpeg";